import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
// @ts-ignore
import {Observable, of, throwError} from 'rxjs';
import {AuthService} from 'ngx-auth';
import {environment} from "../../../environments/environment";
import {TokenStorage} from "./token-storage.service";
import {DataStorageService} from "./data-storage.service";
import {catchError, map, tap} from "rxjs/operators";
// import {Socket} from "ngx-socket-io";
import {Session, User} from "../_models";
import {ToastController} from "@ionic/angular";


interface AccessData {
    session: Session;
    user: User;
}

export function getMe(http: HttpClient, tokenStorage: TokenStorage): Observable<any> {
    return http.get(environment.endpoint + 'users/me')
        .pipe(tap(
            (data: any) => {
                tokenStorage.setLoggedUser(data);
            }
        ));
}

@Injectable()
export class AuthenticationService implements AuthService {
    private endpoint = environment.endpoint;
    private resourceLink = 'authentication';


    constructor(private http: HttpClient,
                private tokenStorage: TokenStorage,
                private dataStorage: DataStorageService,
                private toastController: ToastController,
                // private socketService: Socket,
    ) {


    }


    /**
     * Check, if user already authorized.
     * @description Should return Observable with true or false values
     * @returns {Observable<boolean>}
     * @memberOf AuthService
     */


    public isAuthorized(): Observable<boolean> {
        return this.tokenStorage
            .getAccessToken()
            .pipe(
                tap(
                    (data: any) => {
                    }),
                map(token => !!token)
            );

    }

    /**
     * Get access token
     * @description Should return access token in Observable from e.g.
     * localStorage
     * @returns {Observable<string>}
     */
    public getAccessToken(): Observable<string> {
        return this.tokenStorage.getAccessToken();
    }


    /**
     * Get access token
     * @description Should return access token in Observable from e.g.
     * localStorage
     * @returns {Observable<string>}
     */
    public getTokenDetails(): Observable<string> {
        return this.tokenStorage.getTokenDetails();
    }

    /**
     * Function, that should perform refresh token verifyTokenRequest
     * @description Should be successfully completed so interceptor
     * can execute pending requests or retry original one
     * @returns {Observable<any>}
     */
    public refreshToken(): Observable<AccessData> {
        const accData: AccessData = {
            session: {token: '', expires_at: ''},
            user: {id: 0}
        };

        return of(accData);
    }

    /**
     * Checks if status is 401
     *
     * @description Essentialy checks status
     * @param {Response} response
     * @returns {boolean}
     */
    public refreshShouldHappen(response: HttpErrorResponse): boolean {
        if (response.status === 401) {
            this.tokenStorage.clear();
            location.reload();
        }

        return response.status === 401;
    }

    /**
     * Verify that outgoing request is refresh-token,
     * so interceptor won't intercept this request
     * @param {string} url
     * @returns {boolean}
     */
    public verifyTokenRequest(url: string): boolean {
        // @ts-ignore
        return url.endsWith('/refresh');
    }

    /**
     * EXTRA AUTH METHODS
     */

    /**
     * Register a normal user (customer)
     *
     * @param queryParams
     * @returns {Observable<any>}
     */
    public register(queryParams: any): Observable<any> {
        return this.http.post(this.endpoint + this.resourceLink + '/register', queryParams)
            .pipe(
                catchError((err: any) => {
                    console.log(err);

                    for (const error in err.error.errors) {
                        if (!err.error.errors.hasOwnProperty(error)) {
                            continue;
                        }

                        for (const message of err.error.errors[error]) {
                            console.log(err.error.errors[error]);
                        }
                    }
                    return throwError(err);
                }),
                map(
                    (data) => {
                        console.log(data);
                        return this.login(queryParams);
                    },
                ));

    }

    /**
     * Log in
     *
     * @param queryParams
     * @returns {Observable<any>}
     */
    public login(queryParams: any): Observable<any> {
        return this.http.post(this.endpoint + this.resourceLink + '/login', queryParams)
            .pipe(
                tap((tokens: any) => {
                        this.saveAccessData(tokens);
                        console.log('login made');
                    },
                    err => {
                        console.log('err', err.error.errors[0])
                        this.presentErrorToast(err.error.errors[0]);


                    }
                ))
    }


    /**
     * Log out
     */
    public logout(): Observable<any> {

        return this.http.post(this.endpoint + this.resourceLink + '/logout', {})
            .pipe(tap(
                (data: any) => {
                    const tk: string = <string>localStorage.getItem('authentication-token');
                    // this.socketService.emit('AUTH_SIGNOUT_SUCCESS', {token: tk});
                    //console.log('logout made')
                    this.tokenStorage.clear();
                    location.reload();
                }
            ));
    }


    private saveAccessData(data: AccessData) {
        this.tokenStorage
            .setAccessToken(data.session.token)
            .setTokenDetails(data.session.expires_at)
            .setLoggedUser(data.user);


    }


    public getHeaders(token: string) {
        return {
            'Auth-Token': token
        };
    }


    public forgotPassword(queryParams: any) {
        return this.http.post(this.endpoint + this.resourceLink + '/forgot_password', queryParams).pipe(
            map((data: any) => {
                // success response
                return {
                    ...data,
                    message: data?.message || "Password reset request successful."
                };
            }),
            catchError((err: any) => {
                // error response
                const message = err?.error?.message || "Error requesting password reset.";
                return throwError({ ...err, message });
            })
        );
    }




    public changePassword(queryParams: any) {
        return this.http.post(this.endpoint + this.resourceLink + '/change_reset_password', queryParams).pipe(
            map((data: any) => {
                // success response
                return {
                    ...data,
                    message: data?.message || "Password reset successful."
                };
            }),
            catchError((err: any) => {
                // error response
                const message = err?.error?.message || "Error at password reset.";
                return throwError({ ...err, message });
            })
        );
    }




    public activate(queryParams: any) {
        return this.http.post(this.endpoint + this.resourceLink + '/activate', queryParams)
            .pipe(tap((tokens: any) => {
                   // this.saveAccessData(tokens);
                    return tokens;
                    console.log('register and login made');
                },
                err => {
                    //console.log('err', err.error.errors[0])
                    return err.error.errors[0];
                    this.presentErrorToast(err.error.errors[0]);
                }));

    }

    public change_reset_pass(queryParams: any) {
        return this.http.post(this.endpoint + this.resourceLink + '/change_reset_password', queryParams)
            .pipe(tap((tokens: any) => {
                    // this.saveAccessData(tokens);
                    return tokens;
                    console.log('change made');
                },
                err => {
                    //console.log('err', err.error.errors[0])
                    return err.error.errors[0];
                }));

    }


    async presentErrorToast(message: string) {
        const toast = await this.toastController.create({
            message,
            duration: 3000,
            position: 'bottom',
            color: 'dark', // black theme
            cssClass: 'custom-toast'
        });
        toast.present();
    }

}
